import { gql } from '@grandvisionhq/graphql';

const GET_PRODUCT_BY_SLUG = gql`
  query GetProductBySlug($slug: String!, $facets: [SearchFacetInput!]!) {
    getProductBySlug(slug: $slug, facets: $facets) {
      product {
        __typename
        ... on Product {
          brand
          description
          isPublished
          isReviewEnabled
          metaDescription
          metaTitle
          name
          productType
          slug
          categories {
            name
          }
          ratingsSummary {
            average
            reviewCount
          }
          taxCategory {
            key
            rate {
              amount
              id
            }
          }
          variants {
            ... on Variant {
              description
              displayName
              erpId
              header
              isAllowBackOrder
              isExcludedFromCheckout
              metaTitle
              metaDescription
              opcoBackendId
              sku
              usps
              media {
                images {
                  url
                  dimensions {
                    w
                    h
                  }
                  label
                }
              }
              isPublished
              prices {
                originalPrice {
                  currencyCode
                  amount
                }
                discountedPrice {
                  price {
                    amount
                    currencyCode
                  }
                  discountInformation {
                    value
                    name {
                      locale
                      value
                    }
                    type
                    description {
                      locale
                      value
                    }
                    validity {
                      validFrom
                      validUntil
                    }
                  }
                }
              }
              bestPrice
              loyaltyPoints
              inventory {
                items {
                  channel {
                    key
                    id
                  }
                  quantity
                }
                totalQuantity
              }
            }
          }
        }
        ... on SunglassesProduct {
          id
          productTypeDetails {
            isOfferedWithPrescriptions
          }
          variants {
            variantTypeDetails {
              brandModelCode
              brandModelColorCode
              recommendedCategoryKey
              targetGender
              tags {
                key
                value
              }
              channelAvailability
              isReservable
              isVtoEnabled
              trend
              frameFeatures {
                bridgeWidth
                color
                material
                templeLength
                type
                width
                shape {
                  displayName
                  shape
                }
                size {
                  displayName
                  size
                }
                templeType
              }
              lensFeatures {
                isPolarized
                isGlazeble
                uvRaysProtection
                lensWidth
                lensHeight
                lensColor
              }
              segment
              roadworthiness
            }
          }
        }
        ... on AccessoriesProduct {
          id
          variants {
            variantTypeDetails {
              accessoryType {
                displayName
              }
              brandModelCode
              brandModelColorCode
              recommendedCategoryKey
              targetGender
              tags {
                key
                value
              }
              color
              channelAvailability
              material
            }
          }
        }
      }
    }
  }
`;

export { GET_PRODUCT_BY_SLUG };
//# sourceMappingURL=get-product-by-slug.js.map
